<!--
 * @Author: yaoyuting
 * @Date: 2021-04-11 18:24:56
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2022-04-02 14:09:48
 * @Descripttion:
-->
<template>
    <div class="Client">
        <div class="title">
            <div class="BigTitle">{{ $t("Learn.client") }}</div>
            <div class="SubTitle">{{ $t("Learn.whatClient") }}</div>
            <div class="detail">
                <div>
                    <div class="point" style="background: #000000;"></div>
                    {{ $t("Learn.interest1") }}
                </div>
                <div>
                    <div class="point" style="background: #000000;"></div>
                    {{ $t("Learn.interest2") }}
                </div>
            </div>
        </div>

        <div class="content">
            <div class="adv left">
                <div class="decTitle">
                    <div class="point" style="background: #000000;"></div>
                    <div class="describe">{{ $t("Learn.interest3") }}</div>
                    <div class="sub">{{ $t("Learn.detail3") }}</div>
                </div>
                <div class="decTitle">
                    <div class="point"  style="background: #E10475;"></div>
                    <div class="describe">{{ $t("Learn.interest4") }}</div>
                    <div class="sub">{{ $t("Learn.detail4") }}</div>
                </div>
                <div class="decTitle">
                    <div class="point"  style="background: #4573E7;"></div>
                    <div class="describe">{{ $t("Learn.interest5") }}</div>
                    <div class="sub">{{ $t("Learn.detail5") }}</div>
                </div>
            </div>
            <div class="adv right">
                <div class="intro l">
                    <img src="../../../assets/pc/intro/Abnormal.png">
                </div>
                <div class="intro">
                    <div class="describe"><img src="../../../assets/pc/intro/Stakingfe.png"></div>
                    <div class="describe k"><img src="../../../assets/pc/intro/Security.png"></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    export default {
        data() {
            return {

            };
        },
        mounted() {
            // this.init();
        },
        destroyed() {
        },
        methods: {
        },
    };
</script>

<style lang="less" scoped>
    .Client {
        /*padding: 100px 0 200px;*/
        text-align: center;
        width: 100%;
        background: url("../../../assets/pc/intro/back.png") no-repeat
            center/100% 100%;
        color: #000000;
        .title{
            padding-top: 231px;
            margin: 0 auto;
            width: 1200px;
            // width: 100%;
            .BigTitle{
                text-align: left;
                height: 103px;
                font-size: 70px;
                font-family: Poppins-Black, Poppins;
                font-weight: 900;
                color: #000000;
                line-height: 103px;
                -webkit-background-clip: text;
            }
            .SubTitle{
                padding-top: 45px;
                text-align: left;
                // height: 36px;
                font-size: 24px;
                font-family: Poppins-Medium, Poppins;
                font-weight: 500;
                color: #000000;
                line-height: 28px;
                -webkit-background-clip: text;
            }
            .detail{
                padding-top: 22px;
                height: 90px;
                margin: 0 auto;
                text-align: left;
                font-size: 18px;
                font-family: Poppins-Medium, Poppins;
                font-weight: 500;
                color: #61666B;
                line-height: 30px;
                -webkit-background-clip: text;
            }
        }
        .point{
            float: left;
            margin-right: 15px;
            margin-top: 11px;
            line-height: 30px;
            width: 7px;
            height: 7px;
            background: #E10475;
            border-radius: 2px 2px 2px 2px;
            opacity: 1;
        }
        .content{
            margin-top: 200px;
            width: 1200px;
            margin-bottom: 345px;
            display: inline-block;
            .left{
                width: 400px;
                margin-right: 158px;
            }
            .right{
                width: 600px;
            }
            .adv{
                float: left;
                height: 520px;
                opacity: 1;
                text-align: center;
                .decTitle{
                    margin-bottom: 105px;
                    text-align: left;
                    .describe{
                        height: 31px;
                        font-size: 18px;
                        font-weight: 600;
                        color: #2C1D1A;
                        line-height: 31px;
                    }
                    .sub{
                        margin-left: 22px;
                        width: 395px;
                        font-size: 14px;
                        font-weight: 500;
                        color: #737582;
                        line-height: 24px;
                    }
                }
            }
            .intro{
                float: left;
                .k{
                    margin-top: 10px;
                    margin-left: 0;
                    text-align: left;
                }
            }
            .l{
                margin-right: 15px;
            }
        }

    }

</style>

